// extracted by mini-css-extract-plugin
export default {"container":"JoinCompany_container__j5Tmc","wrapper":"JoinCompany_wrapper__YLdwc","text":"JoinCompany_text__HSw8u","blue":"JoinCompany_blue__hbHpd"};